<template>
  <div class="table">
    <div class="container">
      <div class="handle-box">
        <el-form :model="queryCondition" ref="queryCondition" :label-position="labelPosition" label-width="120px" class="searchForm">
          <el-row>
            <el-col :span="24">
              <el-row :gutter="20">
                <el-col :span="6">
                  <el-form-item label="评价期" prop="appraisePeriod">
                    <el-select v-model="queryCondition.appraisePeriod" clearable placeholder="请选择" style="width:100%">
                      <el-option :key="index" v-for="(item,index) in allDate" :label="item.name" :value="item.code"></el-option>
                    </el-select>
                  </el-form-item>
                </el-col>
                <el-col :span="6">
                  <el-form-item label="Facility名称" prop="facilityName">
                    <el-input v-model="queryCondition.facilityName" clearable style="width:100%"></el-input>
                  </el-form-item>
                </el-col>
                <el-col :span="6">
                  <el-form-item label="Category2" prop="category2CodeList">
                    <el-select v-model="queryCondition.category2CodeList" multiple @change="changeCategory2" clearable style="width:100%" placeholder="请选择">
                      <el-option :key="index" v-for="(item,index) in categoryList2" :label="item.name" :value="item.code"></el-option>
                    </el-select>
                  </el-form-item>
                </el-col>
                <el-col :span="6">
                  <el-form-item label="Category3" prop="category3CodeList">
                    <el-select v-model="queryCondition.category3CodeList" multiple clearable style="width:100%" placeholder="请选择">
                      <el-option :key="index" v-for="(item,index) in categoryList3" :label="item.name" :value="item.code"></el-option>
                    </el-select>
                  </el-form-item>
                </el-col>
              </el-row>
            </el-col>
            <el-collapse-transition>
              <el-col :span="24" v-if="isShow">
                <el-row :gutter="20">
                  <el-col :span="6">
                    <el-form-item label="状态" prop="status">
                      <el-select v-model="queryCondition.status" clearable style="width:100%" placeholder="请选择">
                        <el-option :key="index" v-for="(item,index) in statusList" :label="item.name" :value="item.code"></el-option>
                      </el-select>
                      <!-- <ic-select clearable table="TM_QSPI_FACILITY" field="STATUS" v-model="queryCondition.status" style="width:100%"></ic-select> -->
                    </el-form-item>
                  </el-col>
                  <el-col :span="6">
                    <el-form-item label="供应商集团名称" prop="supplierGroupName">
                      <el-input v-model="queryCondition.supplierGroupName" clearable style="width:100%"></el-input>
                    </el-form-item>
                  </el-col>
                </el-row>
              </el-col>
            </el-collapse-transition>
          </el-row>
          <el-row type="flex" justify="center" align="middle">
            <el-button size="mini" @click="queryData(1)" type="primary">查询</el-button>
            <el-button size="mini" @click="onReset" type="primary">重置</el-button>
            <span class="arrowDown" @click="isShow=!isShow">{{isShow?'收缩':'展开'}}<i :class="isShow?'el-icon-arrow-up iconBtn':'el-icon-arrow-down iconBtn'"></i></span>
          </el-row>
        </el-form>
      </div>
      <el-row class="action-btn-row">
        <el-button v-acl="QSPI_AAA_PUBLISH" size="mini" class="btn" type="primary" @click="release">发布</el-button>
        <el-button v-acl="QSPI_AAA_SENDMAIL" size="mini" class="btn" type="primary" @click="sendEmail">发送邮件</el-button>
        <el-button v-acl="QSPI_AAA_EXPORT" size="mini" class="btn" type="primary" @click="exportList">导出</el-button>
        <el-button v-acl="QSPI_AAA_EXPORT_W_FACTS" size="mini" class="btn" type="primary" @click="exportGrade">导出评分及Facts</el-button>
        <el-button v-acl="QSPI_AAA_EXPORT_RANK" size="mini" class="btn" type="primary" @click="exportSupplier">供应商排名(全量)</el-button>
        <el-button v-acl="QSPI_AAA_EXPORT_RANK" size="mini" class="btn" type="primary" @click="exportRanking">供应商排名(对比去年底)</el-button>
      </el-row>
      <el-table :data="tableData.bodyList" @sort-change="changeTableSort" max-height="500" :cell-style="changeColor" ref="fpaPcnList" border highlight-current-row style="margin-top: 10px ;" class="PQCP" @selection-change="selectionChange" show-overflow="ellipsis">
        <el-table-column type="selection" width="55"></el-table-column>
        <el-table-column v-for="v,i in tableData.headers" :sortable="getLabel(v)?true:false" style="height:100%" :key="i" align="center" :width="setWidth(v)" :prop="v" :label="v" :fixed="setProperty(v)">
          <template v-slot="scope">
            <span v-if="getPeriod(v)" @click="goDetail(scope.row)" :style="{color:(scope.row[i+'_revise']==true?'red':'')}" class="orColor">{{ tableData.bodyList[scope.$index][i] }}</span>
            <el-tooltip v-else-if="getLabel(v)" placement="top">
              <div slot="content">
                <p>供应商自评:{{tableData.bodyList[scope.$index][i]}}</p>
                <p>Facts:{{scope.row[i+'_supplierFacts']}}</p>
                <p>Final Facts:{{scope.row[i+'_finalFacts']}}</p>
              </div>
              <span @click="openDetail(scope.row,i)" :class="scope.row[i+'_revise']==true?'orangeColor':'orColor'">{{ tableData.bodyList[scope.$index][i] }}</span>
            </el-tooltip>
            <!-- <span v-else-if="getLabel(v)" @click="openDetail(scope.row,i)" :style="{color:(scope.row[i+'_revise']==true?'red':'')}" class="orColor">{{ tableData.bodyList[scope.$index][i] }}</span> -->
            <span v-esle style="display: inline-block;width: 100%;height:100%;" :style="{color:(scope.row[i+'_revise']==true?'red':'')}">{{ tableData.bodyList[scope.$index][i] }}</span>
          </template>
        </el-table-column>
      </el-table>

      <div class="pagination">
        <el-pagination @size-change="pageSizeChange" @current-change="pageNumberChange" :current-page="queryCondition.pageNum" :page-sizes="pageSizeList" :page-size="queryCondition.pageSize" :layout="pageLayout" :total="totalCount">
        </el-pagination>
      </div>
    </div>
    <el-dialog title="Final Score" :visible.sync="showDetailDialog" append-to-body width="80%" :close-on-click-modal="false" @close="closeDialog">
      <detailDialog v-if="showDetailDialog" :formData="formData" :dialoagId="dialoagId" :detailInfo="detailInfo" @closeDialog="closeDialog"></detailDialog>
    </el-dialog>
  </div>
</template>
<script>
import IcSelect from "@/components/common/icSelect";
import store from '@/store/index'
import detailDialog from './detail/repairDialog.vue'
import scoreSummary from "@/api/AAA/scoreSummary.js";
import apiService from "@/api/AAA/index.js";
import commonFunction from "@/utils/dataTableUtils";
import QBRApi from "@/api/QBR/index";
import { fileService } from "@/api/common/file-utils";


export default {
  name: '',
  components: {
    IcSelect,
    detailDialog
  },
  data() {
    return {
      dialoagId: "",
      detailInfo: {},
      allDate: [],
      categoryList2: [],
      categoryList3: [],
      statusList: [],
      multipleSelection: [],
      queryCondition: {
        "appraisePeriod": "",
        "category2CodeList": [],
        "category3CodeList": [],
        "facilityName": "",
        "pageNum": 1,
        "pageSize": 15,
        "status": "",
        "supplierGroupName": ""
      },
      isShow: false,
      showDetailDialog: false,
      tableData: [],
      formData: null,
    }
  },
  created() {
    this.getAllDate()
    if (this.$route.query.appraisePeriod) {
      this.queryCondition.appraisePeriod = this.$route.query.appraisePeriod
    }
    this.getStatusList()
    this.getCategory2Lists()
    this.getCategory3Lists()
  },
  mounted() {
    // this.queryData();
  },
  methods: {
    queryData(val) {
      if (undefined != val) {
        this.queryCondition.pageNum = 1
      }
      if (this.queryCondition.appraisePeriod) {
        scoreSummary.getSummaryApage(this.queryCondition).then((res) => {
          res.resultData.bodyList.forEach((v) => {
            v.currentAppraisePeriod = v.currentAppraisePeriod.toFixed()
          })
          this.tableData = res.resultData
          this.totalCount = res.totalCount
        })
      } else {
        this.$message.error('请选择评价期')
      }

    },
    setWidth(row) {
      for (let item in this.tableData.headers) {
        if (this.tableData.headers[item] == row && (item == 'category2' || item == 'rating' || item == 'currentAppraisePeriod' || item == 'vsLastRank' || item == 'lastAppraisePeriod' || item == 'lastBeforeAppraisePeriod' || item == 'vsToLastBefore' || item == 'currentRank' || item == 'vsToLastPeriod' || item == 'lastRank' || item == 'lastBeforeRank' || item == 'vsLastBeforeRank')) {
          return '120'
        }
        if (this.tableData.headers[item] == row && (item != 'category2' || item != 'rating' || item != 'currentAppraisePeriod' || item != 'vsLastRank' || item != 'lastAppraisePeriod' || item != 'lastBeforeAppraisePeriod' || item != 'vsToLastBefore' || item != 'currentRank' || item != 'vsToLastPeriod' || item != 'lastRank' || item != 'lastBeforeRank' || item != 'vsLastBeforeRank')) {
          return '200'
        }
      }
    },
    onDetail(row) {
      this.$router.push({
        path: 'aaaMarkSheet',
        query: {

        }
      })
    },
    openDetail(val, key) {
      sessionStorage.setItem("taskDetail", JSON.stringify(val))
      let id
      for (let item in val) {
        if (item == key) {
          id = val[item + '_id']
        }
      }
      this.dialoagId = id
      scoreSummary.getScoreDetail(id).then((res) => {
        this.detailInfo = res.data
        this.showDetailDialog = true
      })
    },
    onReset() {
      this.$refs['queryCondition'].resetFields();
      this.queryCondition = {
        "appraisePeriod": "",
        "category2CodeList": [],
        "category3CodeList": [],
        "facilityName": "",
        "pageNum": 1,
        "pageSize": 15,
        "status": "",
        "supplierGroupName": ""
      }
      this.queryCondition.pageNum = 1
      let defaultVal = this.allDate.filter((a) => { return a.isDefault })
      if (defaultVal.length > 0) {
        this.$set(this.queryCondition, 'appraisePeriod', defaultVal[0].code)
        // this.queryCondition.appraisePeriodList.push(defaultVal[0].code)
      }
      this.queryData();
    },
    release() {
      if (this.multipleSelection.length != 0) {
        let arr = []
        this.multipleSelection.forEach((v) => {
          arr.push(v.ttQspiAaaScoreId)
        })
        this.$confirm('您确定要进行发布操作吗？', '确认发布', {
          confirmButtonText: '确定发布',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          scoreSummary.summaryRelease(arr).then((res) => {
            if (res.code == 200) {
              this.$message.success('发布成功')
              this.queryData()
            } else {
              const h = this.$createElement
              let arr = []
              let msg = JSON.parse(res)
              msg.msg.split(',').forEach((v, i) => {
                if (i != msg.msg.split(',').length - 1) {
                  arr.push(v.replace('业务数据错误：', '') + '  Fonterra Waitoa Plant状态不允许发布')
                }
              })
              var valid = this.utils.validTable(arr, h)
              if (!valid) {
                return false
              }
            }
          })
        }).catch(() => {
          this.$message({
            type: 'info',
            message: '已取消发布'
          });
        });

      } else {
        this.$message.error('请勾选数据')
      }

    },
    changeColor({ row, column, rowIndex, columnIndex }) {
      if (columnIndex == 5) {
        if (row.vsToLastPeriod < 0) {
          return 'background-color: yellow;color: #000;'
        }
      }
      if (columnIndex == 8) {
        if (row.vsToLastBefore < 0) {
          return 'background-color: yellow;color: #000;'
        }
      }
    },
    pageSizeChange(val) {
      this.queryCondition.pageSize = val
      this.queryData()
    },
    pageNumberChange(val) {
      this.queryCondition.pageNum = val
      this.queryData()
    },
    sendEmail() {
      if (this.multipleSelection.length != 0) {
        let arr = []
        this.multipleSelection.forEach((v) => {
          arr.push(v.ttQspiAaaScoreId)
        })
        scoreSummary.sendEmail(arr).then((res) => {
          if (res.code == 200) {
            this.$message.success('发送成功')
            this.queryData()
          } else {
            const h = this.$createElement
            let arr = []
            let msg = JSON.parse(res)
            msg.msg.split(',').forEach((v, i) => {
              // if(i!=msg.msg.split(',').length-1){
              //  arr.push(v.replace('业务数据错误：','')+ '   还未发布')
              // }else{
              arr.push(v)
              // }
            })
            var valid = this.utils.validTable(arr, h)
            if (!valid) {
              return false
            }

            this.$message.error(res.msg)
          }
        })
      } else {
        this.$message.error("请勾选数据")
      }

    },
    changeTableSort(e) {
      const prop = e.prop
      if (e.order === 'descending') {
        let label = ''
        for (let item in this.tableData.headers) {
          if (this.tableData.headers[item] == prop) {
            label = item
          }
        }
        this.tableData.bodyList = this.tableData.bodyList.sort((a, b) => {
          return parseFloat(b[label]) - parseFloat(a[label])
        })
      } else {
        let label = ''
        for (let item in this.tableData.headers) {
          if (this.tableData.headers[item] == prop) {
            label = item
          }
        }
        this.tableData.bodyList = this.tableData.bodyList.sort((a, b) => {
          return parseFloat(a[label]) - parseFloat(b[label])
        })
      }
    },
    exportList() {
      let ids = []
      this.multipleSelection.forEach((v) => {
        ids.push(v.ttQspiAaaScoreId)
      })
      this.queryCondition.selectedIdList = ids
      scoreSummary.exportSummary(this.queryCondition).then((res) => {
        fileService.respToFile(res);
      })
    },
    exportGrade() {
      let ids = []
      this.multipleSelection.forEach((v) => {
        ids.push(v.ttQspiAaaScoreId)
      })
      this.queryCondition.selectedIdList = ids
      scoreSummary.exportScoreAndFacts(this.queryCondition).then((res) => {
        fileService.resNameToFile(res);
      })
    },
    exportRanking() {
      let ids = []
      this.multipleSelection.forEach((v) => {
        ids.push(v.ttQspiAaaScoreId)
      })
      this.queryCondition.selectedIdList = ids
      scoreSummary.exportSupplierRank(this.queryCondition, this.queryCondition.appraisePeriod).then((res) => {
        //  fileService.resNameToFile(res);
        fileService.respToFile(res, '供应商排名（对比去年底）报表.xlsx');
      })
    },
    exportSupplier() {
      let ids = []
      this.multipleSelection.forEach((v) => {
        ids.push(v.ttQspiAaaScoreId)
      })
      this.queryCondition.selectedIdList = ids
      scoreSummary.exportSupplierChart(this.queryCondition, this.queryCondition.appraisePeriod).then((res) => {
        //  fileService.resNameToFile(res);
        fileService.respToFile(res, this.queryCondition.appraisePeriod + '_供应商排名报表.xlsx');
      })
    },
    onDel() {

    },
    getStatusList() {
      apiService.getAaaStatus().then((res) => {
        this.statusList = res.resultData
      })
    },
    setProperty(v) {
      for (let item in this.tableData.headers) {
        if (this.tableData.headers[item] == v && (item == 'category2' || item == 'supplierGroupName' || item == 'facilityName')) {
          return true
        }
      }
    },
    getLabel(v) {
      for (let item in this.tableData.headers) {
        if (this.tableData.headers[item] == v && item.slice(0, 9) == 'scoreName') {
          return true
        }
      }
    },
    getPeriod(v) {
      for (let item in this.tableData.headers) {
        if (this.tableData.headers[item] == v && item == 'currentAppraisePeriod') {
          return true
        }
      }
    },
    goDetail(row) {
      sessionStorage.setItem("taskDetail", JSON.stringify(row))
      this.$router.push({
        path: "/aaaMarkSheet",
        query: {
          id: row.ttQspiAaaScoreId
        }
      })
    },
    sotrByData(value1, value2) {
      // this.$forceUpdate()
      // return value1-value2
    },
    closeDialog() {
      this.showDetailDialog = false
      this.queryData()
    },
    selectionChange(val) {
      this.multipleSelection = val
    },
    getAllDate() {
      apiService.getAllDate().then((res) => {
        let defaultVal = res.resultData.filter((a) => { return a.isDefault })
        if (defaultVal.length > 0) {
          this.$set(this.queryCondition, 'appraisePeriod', defaultVal[0].code)
          // this.queryCondition.appraisePeriodList.push(defaultVal[0].code)
        }
        this.queryData()
        this.allDate = res.resultData
      })
    },
    getCategory2Lists() {
      var param = {
        categoryLevel: '2',
      }
      QBRApi.getCategoryLists(param).then(res => {
        this.categoryList2 = res.data
      });
    },
    getCategory3Lists() {
      var param = {
        categoryLevel: '3',
      }
      QBRApi.getCategoryLists(param).then(res => {
        this.categoryList3 = res.data
      });
    },
    changeCategory2() {
      this.categoryList3 = []
      QBRApi.getCategoryLists({ categoryLevel: 3, category2Codes: this.queryCondition.category2CodeList }).then((res) => {
        this.categoryList3 = res.data;
      });
    },
  },
  extends: commonFunction
}
</script>
<style scoped >
/deep/ .el-table td {
  padding: 0px 0px !important;
}
.orColor {
  color: #f8ab01;
  display: inline-block;
  width: 100%;
  height: 100%;
  cursor: pointer;
}
.orangeColor {
  color: #fff;
  background: #f8ab01;
  display: inline-block;
  width: 100%;
  height: 100%;
  cursor: pointer;
}
</style>
